import './mapleeventgroup2/style';
import FormStructure from './mapleeventgroup2/form_structure';

export default FormStructure;


// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/includes.js